import React from 'react';
import { useParams } from 'react-router-dom';
import { useOrderDetail } from '../hooks/use-orders';
import { useUserApprovals } from '../hooks/use-user-approvals';

export function DebugOrderDetailPage() {
  const { orderId } = useParams<{ orderId: string }>();
  const { divisionId } = useUserApprovals();

  const { 
    data: orderDetail, 
    isLoading, 
    error 
  } = useOrderDetail(divisionId!, orderId!);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;
  if (!orderDetail) return <div>No order data</div>;

  return (
    <div style={{ padding: '20px', fontFamily: 'monospace' }}>
      <h1>Debug Order Detail</h1>
      <h2>Order ID: {orderId}</h2>
      <h3>Line Items ({orderDetail.lineItems.length}):</h3>
      
      {orderDetail.lineItems.map((item, index) => (
        <div key={index} style={{ 
          border: '1px solid #ccc', 
          margin: '10px 0', 
          padding: '10px',
          backgroundColor: item.id ? '#f0f8ff' : '#ffebee'
        }}>
          <h4>Line Item {index + 1} {!item.id && '(MISSING ID)'}</h4>
          <pre>{JSON.stringify(item, null, 2)}</pre>
        </div>
      ))}
      
      <h3>Full Order Detail:</h3>
      <details>
        <summary>Click to expand full order data</summary>
        <pre style={{ fontSize: '10px', maxHeight: '400px', overflow: 'auto' }}>
          {JSON.stringify(orderDetail, null, 2)}
        </pre>
      </details>
    </div>
  );
}